import { render, staticRenderFns } from "./OrderPrintButton.vue?vue&type=template&id=55864a5a&scoped=true&"
import script from "./OrderPrintButton.vue?vue&type=script&lang=js&"
export * from "./OrderPrintButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55864a5a",
  null
  
)

export default component.exports